import { connect } from 'react-redux';
import PoliticaContaDigitalCreate from './politicaContaDigitalCreate';

export default connect()(PoliticaContaDigitalCreate);
